<template>
	<div
		class="messages-container d-flex align-center justify-center bg-white gap-2 rounded-2 py-1 px-2"
	>
		<div class="pl-2">
			<Icon
				v-if="type === 'error'"
				icon="error"
				class="icon"
				radius="24px"
				alt="toast icon error"
			/>
			<Icon
				v-if="type === 'success'"
				icon="success"
				class="icon"
				radius="24px"
				alt="toast icon check"
			/>
		</div>
		<p class="messages-container--message text-neutral-950 text-body-m">{{ message }}</p>
		<PButton v-if="cta" type="text" color="social" @click="handleClick">
			{{ cta.ctaText }}
		</PButton>
		<PButton type="text" color="neutral" @click="$emit('close')">
			<Icon icon="close" radius="16px" :stroke-width="2" />
		</PButton>
	</div>
</template>

<script setup lang="ts">
	export type ToastType = 'error' | 'success'
	export type ToastCta = { ctaText: string; callback: () => void }
	import Icon from './Icon.vue'

	interface Props {
		message: string
		type: ToastType
		cta?: ToastCta
	}

	const props = defineProps<Props>()
	const emit = defineEmits(['close'])

	function handleClick() {
		props.cta?.callback()
		emit('close')
	}
</script>

<style lang="scss" scoped>
	.messages-container {
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		max-width: 400px;
		min-height: 54px;
		width: 100%;

		& .messages-container--message {
			flex: 1;
			width: 100%;
			&.option-text {
				text-align: left;
				color: var(--v-primary-base);
			}
		}
	}
	.close-button {
		background-color: transparent;
	}
	.icon {
		align-self: baseline;
	}
</style>
